import React from 'react';
import TextField from '@material-ui/core/TextField';
import { Typography } from '@material-ui/core';

export default function BrokerageDropDown({ top }) {
  const value =
    top.dataSource === 'LIVE'
      ? top.accountNumber && top.accountNumber !== 'none'
        ? top.brokerage || 'Select account'
        : 'Select account'
      : 'BACKTEST';

  return (
    <TextField
      value={value}
      variant="outlined"
      size="small"
      style={{ backgroundColor: 'white', width: '100%' }}
      label={<Typography style={{ fontSize: 10 }}>Execution</Typography>}
      InputProps={{ readOnly: true }}
    />
  );
}
